/**
 * Add a new company
 *
 * @param company
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as cargoActions from "../graphql/actions/cargo";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as fogsActions from "./fog";
import * as utils from "../utils/utils";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";

export function add(cargo, displayAll = false) {
    if (!utils.notNullNorUndefined(cargo.excessExclusion)) {
        cargo.excessExclusion = false;
    }

    return dispatch => {
        dispatch(loading());
        dispatch(saving(cargo));
        cargoActions.add(
            function (response) {
                dispatch(saved(response.data.createCargo));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedCargo(response.data.createCargo));
                dispatch(fogsActions.fetchFogs(true, displayAll));
                dispatch(fetchCargoes(cargo.fog, true));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            cargo
        );
    };
}

export function deleteCargo(cargoID, fogID) {
    return dispatch => {
        var url = ajaxRoutes.API_ROUTE + "/cargo/delete/"+cargoID;
        var headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingCargo());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(() => {
                dispatch(doneDeletingCargo());
                dispatch(fetchCargoes(fogID, true));
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingCargo());
            });
    };
}

export function duplicateCargo(cargoID, fogID) {
    return dispatch => {
        var url = ajaxRoutes.API_ROUTE + "/cargo/duplicate/"+cargoID;
        var headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});

        dispatch(deletingCargo());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(() => {
                dispatch(doneDeletingCargo());
                dispatch(fetchCargoes(fogID, true));
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingCargo());
            });
    };
}

export function edit(cargo, displayAll = false) {
    let id = cargo.id;
    delete cargo.id;
    delete cargo.__typename;
    delete cargo.shortagePercent;
    delete cargo.shortageTonnes;
    delete cargo.dischargingPort;
    delete cargo.loadingPort;
    delete cargo.commodityName;

    if (!utils.notNullNorUndefined(cargo.excessExclusion)) {
        cargo.excessExclusion = false;
    }

    return dispatch => {
        dispatch(loading());
        dispatch(saving(cargo));
        cargoActions.edit(
            function (response) {
                dispatch(saved(response.data.editCargo));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(fogsActions.fetchFogs(true, displayAll));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            cargo
        );
    };
}


export function fetchCargoes(fogId, force = false) {
    return dispatch => {
        dispatch(loading());
        cargoActions.getCargoes(
            function (response) {
                dispatch(receiveCargoes(response.data.cargoes));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            fogId,
            force
        );
    };
}


export function get(id, force = false) {
    return dispatch => {
        dispatch(loading());
        cargoActions.get(
            function (response) {
                dispatch(receiveCargo(response.data.cargo));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            id,
            force
        );
    };
}




export function loading() {
    return {
        type: types.LOADING_CARGO
    };
}

export function doneDeletingCargo() {
    return {
        type: types.DONE_DELETING_CARGO
    };
}

export function deletingCargo() {
    return {
        type: types.DELETING_CARGO
    };
}

export function saving(cargo) {
    return {
        type: types.SAVING_CARGO,
        payload: cargo
    };
}

export function saved(cargo) {
    return {
        type: types.SAVED_CARGO,
        payload: cargo
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_CARGO,
    };
}

export function receiveCargoes(data) {
    return {
        type: types.RECEIVED_CARGOES,
        payload: data
    };
}

export function receiveCargo(data) {
    return {
        type: types.RECEIVED_CARGO,
        payload: data
    };
}

export function updateFormDataCargo(formData = {}) {
    return {
        type: types.UPDATEFORMDATA_CARGO,
        payload: {
            formData: formData
        }
    }
}

export function clearFormDataCargo() {
    return {
        type: types.CLEARFORMDATA_CARGO
    }
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/cargo.js